import React from "react"
import { css } from "@emotion/core"

const selected = css`
  background: var(--color-interactive-light);
  color: var(--color-text-negative);
  &:hover {
    cursor: pointer;
    color: var(--color-text);
    transition: all 100ms linear;
    -webkit-transition: all 100ms linear;
  }
`

export default function Tag({ tag, setState, state }) {
  const [checked, setChecked] = React.useState(false)

  const filterPosts = event => {
    setChecked(!checked)
    let query = state.query
    query[tag] = !checked

    const filteredData = state.allPosts.filter(post => {
      const tags = post.node.frontmatter.tags
      return tags.some(t => {
        return state.query[t]
      })
    })
    setState({
      checked: state.checked,
      allPosts: state.allPosts,
      filteredData: filteredData,
      query: query,
    })
  }

  return (
    <li
      css={css`
        display: inline-block;
      `}
    >
      <button
        aria-label="Blog Post Topic Tag"
        css={css`
          padding: 8px;
          padding-left: 13px;
          padding-right: 13px;
          font-weight: bold;
          color: var(--color-text);
          margin-right: 20px;
          font-size: 14px;
          background: var(--color-lighter-primary);
          border-radius: 5px;
          &:hover {
            cursor: pointer;
            color: var(--color-interactive-light);
            transition: all 100ms linear;
            -webkit-transition: all 100ms linear;
          }
          ${checked && selected}
        `}
        onClick={filterPosts}
      >
        {tag}
      </button>
    </li>
  )
}
